import type { JSX } from 'react'
import { ALPHABET, NON_ALPHA_LETTER } from '#src/participantList.ts'

interface AlphabetIndexProps {
  // Letters that currently have participants; others render dimmed and inert.
  available: Set<string>
  onSelect: (letter: string) => void
  className?: string
}

// A vertical A-Z jump rail (iOS contacts style). Tapping an active letter asks
// the parent to scroll to that letter's first participant.
export function AlphabetIndex({
  available,
  onSelect,
  className,
}: AlphabetIndexProps): JSX.Element {
  const letters = available.has(NON_ALPHA_LETTER)
    ? [...ALPHABET, NON_ALPHA_LETTER]
    : ALPHABET

  return (
    <nav
      className={`flex flex-col items-center gap-0.5 select-none ${className ?? ''}`}
      aria-label="Jump to letter"
    >
      {letters.map((letter) => {
        const isActive = available.has(letter)
        return (
          <button
            key={letter}
            type="button"
            disabled={!isActive}
            onClick={() => onSelect(letter)}
            className={`flex h-7 w-7 items-center justify-center rounded-full text-sm font-semibold transition-colors ${
              isActive
                ? 'text-primary hover:bg-accent'
                : 'text-muted-foreground/30'
            }`}
          >
            {letter}
          </button>
        )
      })}
    </nav>
  )
}
